import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import ArtworkDetails from '../components/ArtworkDetails';
import ArtworkSkeleton from '../components/ArtworkSkeleton';
import VirtualizedGallery from '../components/VirtualizedGallery';
import LazyEmotionTooltip from '../components/LazyEmotionTooltip';
import useContainerWidth from '../hooks/useContainerWidth';
import { axiosInstance } from '../context/AuthContext';

const AllArtworksPage = () => {
  const [artworks, setArtworks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [containerRef, containerWidth] = useContainerWidth();

  const shouldVirtualize = artworks.length > 20;

  useEffect(() => {
    const fetchArtworks = async () => {
      
      setIsLoading(true);
      setError(null);
      
      try {
        // Fetch all artworks - using homepage view to get all artworks
        const response = await axiosInstance.get('/artworks?view=homepage');
        const json = response.data;
        console.log('Fetched all artworks:', json);

        // Handle different response structures
        if (json.artworks && Array.isArray(json.artworks)) {
          setArtworks(json.artworks);
        } else if (Array.isArray(json)) {
          setArtworks(json);
        } else {
          setArtworks([]);
        }
      } catch (error) {
        console.error('Error fetching artworks:', error);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchArtworks();
  }, []);

  return (
    <>
      <Navbar />
      <div className="flex flex-col min-h-screen pt-4 AllArtworksPage ml-12">
        <div className='self-center py-8 text-5xl font-bold headFont'>
          <h1 className='text-sky-950 uppercase'>All Artworks</h1>
        </div>

        {error && (
          <div className="mx-auto p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg max-w-md">
            <p>Error loading artworks: {error}</p>
          </div>
        )}

        <div ref={containerRef} className='px-16 mx-auto gallery'>
          {isLoading ? (
            <div className='grid gap-10 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2'>
              {Array.from({ length: 8 }, (_, index) => (
                <ArtworkSkeleton key={index} />
              ))}
            </div>
          ) : shouldVirtualize ? (
            <VirtualizedGallery artworks={artworks} containerWidth={containerWidth} />
          ) : (
            <div className='grid gap-10 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2'>
              {artworks.map((artwork) => (
                <LazyEmotionTooltip key={artwork._id} artworkId={artwork._id}>
                  <div className="overflow-visible">
                    <ArtworkDetails artwork={artwork} />
                  </div>
                </LazyEmotionTooltip>
              ))}
            </div>
          )}
        </div>

        {!isLoading && artworks.length === 0 && !error && (
          <div className="text-center py-8">
            <p className="text-gray-500 text-lg">No artworks found.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default AllArtworksPage;

